import { ButtonIcon } from '@/components';

interface DocumentDownloadButtonsCompactProps {

  isViewing: boolean;
  isDownloading: boolean;
  isBusy: boolean;
  onView: () => void;
  onDownload: () => void;
  viewAriaLabel: string;
  downloadAriaLabel: string;
}

/**
 * DocumentDownloadButtonsCompact - Icon-only button variation
 * Displays buttons on the right side of the card with only icons, suitable for small screens
 */
export function DocumentDownloadButtonsCompact({
  isViewing,
  isDownloading,
  isBusy,
  onView,
  onDownload,
  viewAriaLabel,
  downloadAriaLabel,
}: DocumentDownloadButtonsCompactProps) {
  return (
    <div className="flex flex-row items-center gap-1">
      <ButtonIcon
        icon="eye"
        ariaLabel={viewAriaLabel}
        loading={isViewing}
        disabled={isBusy}
        onClick={() => void onView()}
      />

      <ButtonIcon
        icon="download"
        ariaLabel={downloadAriaLabel}
        loading={isDownloading}
        disabled={isBusy}
        onClick={() => void onDownload()}
      />
    </div>
  );
}
